var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plv-iar-module-container-default"},[_c('div',{staticClass:"plv-iar-module-container-default__body",class:{
      'plv-iar-module-container-default__body--border': _vm.withBorder
    },style:({
      height: (_vm.maxBodyHeight + "px"),
    }),on:{"scroll":_vm.onScroll}},[_c('div',{ref:"bodyMain"},[_vm._t("default")],2)]),_vm._v(" "),_c('div',{staticClass:"plv-iar-module-container-default__footer"},[_vm._t("footer")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }